import React from "react";
import { 
  Box, VStack, HStack, Text, Badge, Icon, Checkbox, 
  Collapse, Textarea, CloseButton
} from "@chakra-ui/react";
import { FaFileAlt, FaChevronDown, FaChevronUp } from "react-icons/fa";
import { motion } from "framer-motion";

const MotionBox = motion(Box);

const CustomContextList = ({
  filteredCustomContexts,
  customContexts,
  apiData,
  checkedPages,
  handleCheckboxChange,
  expandedIndex,
  toggleExpand,
  handleRemoveCustomContext,
  cardBg,
  secondaryColor,
  collapseBg,
  borderColor
}) => {
  return (
    <VStack spacing={3} align="stretch">
      {filteredCustomContexts.length === 0 && (
        <Box p={6} textAlign="center" bg={cardBg} borderRadius="lg" opacity={0.7}>
          <Icon as={FaFileAlt} boxSize={10} color="gray.400" mb={3} />
          <Text color="gray.500">
            {customContexts.length === 0 
              ? "No custom contexts available. Click 'Add Custom' to create one."
              : "No custom contexts match your search. Try different search terms."}
          </Text>
        </Box>
      )}
      
      {filteredCustomContexts.map((context, index) => (
        <MotionBox 
          key={index}
          bg={cardBg}
          borderRadius="lg" 
          boxShadow="sm"
          borderLeft="4px solid"
          borderLeftColor={checkedPages.includes(apiData.length + index) ? secondaryColor : "transparent"}
          overflow="hidden"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.3, delay: index * 0.05 }}
          whileHover={{ boxShadow: "md" }}
        >
          <HStack 
            p={4} 
            onClick={() => toggleExpand(apiData.length + index)} 
            cursor="pointer"
            justify="space-between"
            align="center"
          >
            <HStack flex={1}>
              <Checkbox
                isChecked={checkedPages.includes(apiData.length + index)}
                onChange={(e) => {
                  e.stopPropagation();
                  handleCheckboxChange(apiData.length + index);
                }}
                colorScheme="purple"
                size="lg"
              />
              <VStack align="start" spacing={0} ml={2}>
                <Text fontWeight="bold" fontSize="md" noOfLines={1}>
                  {context.name}
                </Text>
                <HStack>
                  <Badge colorScheme="purple" variant="subtle">
                    {context.text.length.toLocaleString()} chars
                  </Badge>
                  <Badge colorScheme="gray" variant="subtle">
                    Custom
                  </Badge>
                  {checkedPages.includes(apiData.length + index) && (
                    <Badge colorScheme="purple">Selected</Badge>
                  )}
                </HStack>
              </VStack>
            </HStack>
            
            <HStack>
              <Icon 
                as={expandedIndex === apiData.length + index ? FaChevronUp : FaChevronDown} 
                boxSize={4}
                color="gray.500"
              />
              <CloseButton 
                size="sm" 
                onClick={(e) => handleRemoveCustomContext(index, e)}
                color="red.500"
              />
            </HStack>
          </HStack>
          
          <Collapse in={expandedIndex === apiData.length + index}>
            <Box 
              p={4} 
              pt={0}
              bg={collapseBg}
              borderTop="1px solid"
              borderTopColor={borderColor}
            >
              <Textarea
                value={context.text}
                isReadOnly
                fontSize="sm"
                height="150px"
                fontFamily="monospace"
                bg={cardBg}
                mt={3}
              />
            </Box>
          </Collapse>
        </MotionBox>
      ))}
    </VStack>
  );
};

export default CustomContextList;